import { AssetClassAnnualReturns } from 'types/annual-returns';

export const annualReturnsData: AssetClassAnnualReturns = {
	annualReturnsData: [
		{
			name: '2022 H1',
			fundrise: '5.52%',
			reits: '-19.31%',
			stocks: '-19.96%'
		},
		{
			name: '2021',
			fundrise: '22.99%',
			reits: '39.88%',
			stocks: '28.71%'
		},
		{
			name: '2020',
			fundrise: '7.31%',
			reits: '-5.86%',
			stocks: '18.40%'
		},
		{
			name: '2019',
			fundrise: '9.16%',
			reits: '28.07%',
			stocks: '31.49%'
		},
		{
			name: '2018',
			fundrise: '8.81%',
			reits: '-4.10%',
			stocks: '-4.38%'
		},
		{
			name: '2017',
			fundrise: '10.63%',
			reits: '9.27%',
			stocks: '21.83%'
		}
	],
	annualReturnsSummaries: [
		{
			name: 'Worst quarter',
			fundrise: '1.15%',
			reits: '-25.42%',
			stocks: '-19.60%'
		},
		{
			name: 'Best quarter',
			fundrise: '9.40%',
			reits: '16.70%',
			stocks: '20.54%'
		},
		{
			name: 'Positive quarters',
			fundrise: '22',
			reits: '17',
			stocks: '17'
		},
		{
			name: 'Negative quarters',
			fundrise: '0',
			reits: '5',
			stocks: '5'
		},
		{
			name: 'Avg. income return',
			fundrise: '5.42%',
			reits: '4.34%',
			stocks: '2.17%'
		}
	]
};
